import axios from 'axios';
import { createQuery } from 'react-query-kit';

import { restUrl } from '@/services/utils';

export interface ValidationStatistic {
    key: string;
    name?: string;
    count?: number;
}

const useValidationStatistics = createQuery<ValidationStatistic[], { name: string }>({
    queryKey: ['browse', 'validationStatistics'],
    fetcher: async (variables) => {
        const response = await axios.get<ValidationStatistic[]>(
            restUrl(`statistics/dynamic/${variables.name}`),
        );
        return response.data ?? [];
    },
});

/** `GET /statistics/dynamic/__validation_overview` */
export const useValidationErrors = () =>
    useValidationStatistics({ variables: { name: '__validation_overview' } });

/** `GET /statistics/dynamic/__validation_warnings` */
export const useValidationWarnings = () =>
    useValidationStatistics({ variables: { name: '__validation_warnings' } });
